import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Portfolio from "./components/Portfolio";
import PrivacyJamb from "./components/PrivacyJamb";
import AdminDashboard from "./components/AdminNotifs";
import AdminJamb from "./components/AdminJamb";
import AdminWaec from "./components/AdminWaec";
import KinteronLanding from "./components/Homepage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<KinteronLanding />} />
        <Route path="/dev" element={<Portfolio />} />
        <Route path="/privacyj" element={<PrivacyJamb />} />
        <Route path="/adminnotifshula" element={<AdminDashboard />} />
        <Route path="/adminjamb0" element={<AdminJamb />} />
        <Route path="/adminwaec0" element={<AdminWaec />} />
      </Routes>
    </Router>
  );
}

export default App;
